const endpoints = {
  flags: 'flags.json'
};

export default endpoints;
